import axios from "@/utils/axios";
import { Guid } from "@/domain/guid";
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";


export default {
	async fetchRosters(teamID: Guid): Promise<GetRostersResponse> {
		return (await axios().get(`/rosters/?teamID=${teamID}`)).data;
	},
	async fetchTeamCharacters(teamID: Guid): Promise<any> {
		return (await axios().get(`/teams/${teamID}/characters/`)).data;
	},
	async refreshRoster(rosterID: Guid): Promise<void> {
		return (await axios().patch(`/rosters/${rosterID}/characters/items/`)).data;
	},
	async refreshAllRosters(teamID: Guid): Promise<void> {
		return (await axios().patch(`/rosters/characters/items/?teamID=${teamID}`)).data;
	},
	async saveAll(rosters: any[]): Promise<void> {
		return (await axios().put("/rosters/", rosters)).data;
	},
	async createRoster(teamID: Guid): Promise<Guid> {
		return (await axios().post(`/teams/${teamID}/rosters/`)).data;
	},
	async deleteRoster(rosterID: Guid): Promise<void> {
		return (await axios().delete(`/rosters/${rosterID}`)).data;
	}
};